import { inject, injectable } from 'inversify';
import { SocketProcessingAdapter } from '@dealroadshow/file-uploader';
import type { ISocketClient } from '@evercall/socket-client';
import EvercallSocketDITypes from '@evercall/socket-client/DITypes';
import { ISocketProcessingAdapter } from './DI/interfaces';

@injectable()
export class EvercallSocketProcessingAdapter extends SocketProcessingAdapter implements ISocketProcessingAdapter {
  constructor(@inject(EvercallSocketDITypes.SocketClient) socketClient: ISocketClient) {
    super(socketClient);
  }
}
